import { defaultServiceContext } from "@app/contexts";
import { useCanvasTabs } from "@app/hooks";
import { IconClass } from "@app/types";
import { Constant } from '../const';
import { waitForCanvas } from "./functions";
import './jquery-plugins/on-resize';

const { errorMessageService, loadingService } = defaultServiceContext;

export default class Config {
  constructor() {
    this.initDebugConfig();
  }
  
  /**
   * Set debug configurations
   */
  initDebugConfig() {
    this.debug = {};
    this.debug.enabled = false;
    this.debug[Constant.k.DEBUG_FORM] = true;
    this.debug[Constant.k.DEBUG_TREE] = false;
    this.debug[Constant.k.DEBUG_STORAGE] = false;
    this.debug[Constant.k.DEBUG_CACHE] = true;
    this.debug[Constant.k.DEBUG_UI] = false;
  }

  /**
   * Initialize layout and treeviews
   */
  initLayoutConfig() {
    this.initTrees();
    this.initLayout();
    const treeDom = $("#tl_container");

    // Load application tree with delay
    clearInterval(this.updateTimer);
    this.updateTimer = setInterval(() => {
      var treeObj = treeDom.jstree();
      if (treeObj && treeObj.settings && treeObj.settings.core) {
        clearInterval(this.updateTimer);
        treeObj.settings.core.data = window.apm.getTree();
        let sortfunc = function(a, b){
          let a1 = this.get_node(a);
          let b1 = this.get_node(b);
          if (a1.icon === b1.icon){
            return (a1.text > b1.text) ? 1 : -1;
          } else {
            return (a1.icon > b1.icon) ? 1 : -1;
          }
        };
        treeObj.settings.sort = sortfunc;
        treeObj.refresh();
      }
        
      }, 200);
  }

  /** Initialize layout for the entire editor */
  initLayout() {
    $("#tree_library")
      .find(".tree-title-text")
      .html(window.l.library.application);
    $("#tree_member")
      .find(".tree-title-text")
      .html(window.l.library.current_diagram);

    $("#tl_q").attr("placeholder", window.l.popup.search);
    $("#tl_q").attr("autocomplete", "off");
    $("#tl_q,#tm_q").keypress(function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        $(this).trigger("blur");
      } else {
        return $(this).val();
      }
    });
    $("#tm_q").attr("placeholder", window.l.popup.search);
  }

  /**
   * Initialize layout and event handling for both treeviews
   */
  initTrees() {
    // TODO: find another place to initialze folders
    if(!window.apm.serialized.folders) {
      window.apm.serialized.folders = {};
      window.apm.serialized.folders.modules = [];
    }

    function isFolder(type) {
      return (
        type === "folders" ||
        type === "modules" ||
        type === "intents" ||
        type === "objects" ||
        type === "variables"
      );
    }
    function isDraggable(type) {
      return type !== "variable" && type !== "intent";
    }

    $("#tl_container")
      .jstree({
        core: {
          check_callback: true,
          data: [
            {
              id: "variables",
              text: window.l.library.variables,
              type: "variables",
              children: []
            },
            {
              id: "modules",
              text: window.l.library.modules,
              type: "modules",
              children: []
            },
            {
              id: "objects",
              text: window.l.library.objects,
              type: "objects",
              children: []
            },
            {
              id: "intents",
              text: window.l.library.intents,
              type: "intents",
              children: []
            }
          ],
          multiple: true,
          themes: {
            dots: false, // no connecting dots between dots
            ellipsis: false,
            stripes: false
          },
          expand_selected_onload: false,
          strings: {
            "New node": "Unnamed"
          }
        },
        types: {
          objects: {
            icon: false,
            valid_children: ["objects", "object"]
          },
          modules: {
            icon: false,
            valid_children: ["modules", "module"]
          },
          intents: {
            icon: false,
            valid_children: ["intents", "intent"]
          },
          variables: {
            icon: false,
            valid_children: ["variables", "variable"]
          },
          object: {
            icon: IconClass.disc,
            valid_children: []
          },
          module: {
            icon: IconClass.package,
            valid_children: []
          },
          intent: {
            icon: IconClass.radio,
            valid_children: []
          },
          variable: {
            icon: IconClass.hash,
            valid_children: []
          }
        },
        search: {
          show_only_matches: true,
          search_leaves_only: true,
          close_opened_onclear: false,
          dom_only_show_only_matches: true,
          max_results: 400,
          show_only_matches_max: 0
        },
        plugins: ["types", "search", "sort"]
      })
      .on("dblclick.jstree", async function (e) {
        const { addTab, isTabOpen } = useCanvasTabs.getState();
        const node = $(this)
          .jstree()
          .get_node(e.target);

        if (node.type === "module") {
          if (!window.apm.hasPermission(node.id, "read")) {
            window.apm.notification.post("error", window.l.notification.no_permission);
            return;
          }

          const loadingMessageId = (isTabOpen(node.id)) ? null : (
            loadingService.addMessage('Loading Module...')
          );

          addTab(node.id);
          if (loadingMessageId) {
            try {
              await waitForCanvas(node.id);
            } catch (error) {
              await errorMessageService.addError(error);
            } finally {
              loadingService.removeMessage(loadingMessageId);
            }
          }
        }
      })
      .on("select_node.jstree", 
        // debouncing so that select doesn't execute when user is dbclicking 
        _.debounce((e, data) => {
            window.apm.postEventToCurrentView({
              target: "request-clear-selection",
            })
            if (data.event && !isFolder(data.node.type)) {
              window.apm.postEventToCurrentView({
                target: "request-component-panel",
                event: data.node,
              })
            }
        }, 150)
      )
      .on("hover_node.jstree", function (_, data) {
        window.apm.printDebug("hover data", data, Constant.k.DEBUG_TREE);
        const { activeTabId } = useCanvasTabs.getState();
        const anchor = $("#" + data.node.a_attr.id);
        // DEVDES2-1046: Disabled modules cannot be dragged and dropped onto canvas
        const isTargetModuleDisabledInFlow = window.apm.serialized.components.modules.find((mod) => {
          return mod.id === activeTabId;
        }).props.config.disabledInFlow;

        if (anchor.length) {
          if (!isFolder(data.node.type)) {
            anchor[0].draggable = "true";
          } else {
            anchor[0].draggable = "false";
          }
        }
        if (
          data.node.type === "module" &&
          window.apm.hasPermission(data.node.id, "read")
        ) {
          const node = window.apm.getNode(data.node.id);
          window.apm.postEventToCurrentView({
            target: "request-render-preview",
            node: node,
            domContext: anchor,
            isTargetModuleDisabledInFlow
          });
        }
      })
      .on("dehover_node.jstree", function () {
        window.apm.postEventToCurrentView({ target: "request-cancel-preview" });
      })
      .on("dragstart.jstree", function (e) {
        const { activeTabId } = useCanvasTabs.getState();
        const isTargetModuleDisabledInFlow = window.apm.serialized.components.modules.find((mod) => {
          return mod.id === activeTabId;
        }).props.config.disabledInFlow;
        window.apm.printDebug("dragstart", e, Constant.k.DEBUG_TREE);
        window.apm.postEventToCurrentView({ target: "request-cancel-preview" });
        const node = $(this)
          .jstree()
          .get_node(e.target);

        
        // prevent dragndrop of disabled nodes to canvas unless current canvas is a disabled module
        if(node.li_attr.class === 'disabledInFlow'){
          // DEVDES2-1046: Disabled modules cannot be dragged and dropped onto canvas
          if(!isTargetModuleDisabledInFlow){
            e.preventDefault();
            e.stopPropagation();
            return;   
          }
        }

        if (!isFolder(node.type) && isDraggable(node.type)) {
          window.apm.cache.put(
            Constant.k.NAMESPACE_DATATRANSFER,
            "dragndrop",
            window.apm.getNode(node.id)
          );
        }
      })
      .on("contextmenu.jstree", function (e) {
        e.preventDefault();
        const node = $(this).jstree().get_node(e.target);
        const nodes = $(this).jstree().is_selected(e.target) ? $(this).jstree().get_selected(true) : [node];
        window.apm.postEventToCurrentView({
          target: "request-tree-menu",
          nodes: nodes,
          event: e
        });
        if (
          // Property panel does not exist for folders.
          !isFolder(node.type)
          // The intent dialog would cover the context menu.
          && node.type !== 'intent'
        ) {
          window.apm.postEventToCurrentView({
            target: "request-component-panel",
            event: node
          });
        }
      });

    window.apm.initDisplayPrefs();

    $("#tm_container")
      .jstree({
        core: {
          check_callback: true,
          data: [
            // currentMod is the cutrently opened module in the canvas
            {
              id: "currentMod",
              text: "Current Module",
              type: "currentMod",
              state: { opened: true },
              children: []
            },
            {
              id: "variables",
              text: window.l.library.local_variables,
              type: "variables",
              state: { opened: true },
              children: []
            },
            {
              id: "modules",
              text: window.l.library.modules,
              type: "modules",
              state: { opened: true },
              children: []
            },
            {
              id: "objects",
              text: window.l.library.objects,
              type: "objects",
              state: { opened: true },
              children: []
            }
          ],
          multiple: false, // no multiselection
          themes: {
            dots: false // no connecting dots between dots
          }
        },
        types: {
          currentMod: {
            icon: false,
            valid_children: ["module"]
          },
          objects: {
            icon: false,
            valid_children: ["objects", "object"]
          },
          modules: {
            icon: false,
            valid_children: ["module"]
          },
          variables: {
            icon: false,
            valid_children: ["variable"]
          },
          object: {
            icon: IconClass.disc,
            valid_children: []
          },
          module: {
            icon: IconClass.package,
            valid_children: []
          },
          variable: {
            icon: IconClass.hash,
            valid_children: []
          }
        },
        search: {
          show_only_matches: true,
          search_leaves_only: true,
          close_opened_onclear: false,
          dom_only_show_only_matches: true,
          max_results: 400,
          show_only_matches_max: 0
        },
        plugins: ["types", "search", "sort"]
      })
      .on("dblclick.jstree", function (e) {
        // CM TODO: module versions and flowVersion: remove or refactor flowVersion
        const node = $(this)
          .jstree()
          .get_node(e.target);
        if (node.type === "module") {
          window.apm.postEventToCurrentView({
            target: "request-open-module",
            event: { 
              id: model.model.getID(),
              version: model.model.props.flowVersion || 1
          } 
          });
        }
      })
      .on("select_node.jstree", function (e, data) {
        // if not currentModule select and center node on canvas
        if (data.event && data.node.parent !== "currentMod") {
          window.apm.postEventToCurrentView({
            target: "request-select-matching",
            event: data.node
          });
        } 
        // if currentModule then nothing on canvas to select, just open property panel
        if(data.event && data.node.parent === "currentMod"){
          window.apm.postEventToCurrentView({
            target: "request-component-panel",
            event: data.node,
          })
        }
      })
      .on("hover_node.jstree", function (e, data) {
        const anchor = $("#" + data.node.a_attr.id);
        if (anchor.length) {
          anchor[0].draggable = "false";
        }
      })
      .on("deselect_all.jstree", function (e, data) { })
      .on("contextmenu.jstree", function (e) {
        e.preventDefault();
        const node = $(this)
          .jstree()
          .get_node(e.target);
        $(this)
          .jstree()
          .deselect_all();
        $(this)
          .jstree()
          .select_node(node);
        window.apm.postEventToCurrentView({
          target: "request-tree-menu",
          node: node,
          local: true,
          event: e
        });
      });

    $("#left-panels").onResize({
      localStorageId: "resize:left-panels",
      maxSize: 700,
      minSize: 220,
      side: "left"
    });

    const libraryTree = $("#tree_library");
    const memberTree = $("#tree_member");

    function updateTreeviews() {
      if (libraryTree.data("open")) {
        libraryTree
          .addClass("open")
          .find(".title-prefix-icon > i")
          .removeClass("icon-chevrons-down")
          .addClass("icon-chevrons-up");
      } else {
        libraryTree
          .removeClass("open")
          .find(".title-prefix-icon > i")
          .removeClass("icon-chevrons-up")
          .addClass("icon-chevrons-down");
      }
      if (memberTree.data("open")) {
        memberTree
          .addClass("open")
          .find(".title-prefix-icon > i")
          .removeClass("icon-chevrons-down")
          .addClass("icon-chevrons-up");
      } else {
        memberTree
          .removeClass("open")
          .find(".title-prefix-icon > i")
          .removeClass("icon-chevrons-up")
          .addClass("icon-chevrons-down");
      }
    }

    libraryTree.data("open", true);
    memberTree.data("open", true);
    updateTreeviews();

    libraryTree.find(".tree-title").on("click", function (event) {
      if ($(event.target).hasClass("form-button")) {
        window.apm.postEventToCurrentView({
          target: "request-tree-title-menu",
          type: "library",
          dom: $(event.target)
        });
        return;
      }
      const newOpen = !libraryTree.data("open");
      if (newOpen) {
        libraryTree.children(".tree-container").show();
      } else {
        libraryTree.children(".tree-container").hide();
      }
      libraryTree.data("open", newOpen);
      updateTreeviews();
    });

    memberTree.find(".tree-title").on("click", function (event) {
      if ($(event.target).hasClass("form-button")) {
        window.apm.postEventToCurrentView({
          target: "request-tree-title-menu",
          type: "member",
          dom: $(event.target)
        });
        return;
      }
      const newOpen = !memberTree.data("open");
      if (newOpen) {
        memberTree.children(".tree-container").show();
      } else {
        memberTree.children(".tree-container").hide();
      }
      memberTree.data("open", newOpen);
      updateTreeviews();
    });

    const bindTreeSearch = ({
      formSelector,
      inputSelector,
      treeSelector,
      searchDelay,
      ensureTreeVisible,
      statusSelector
    }) => {
      const searchForm = $(formSelector);
      const searchInput = $(inputSelector);
      let previousQuery = null;

      const announceResults = (query, matchCount) => {
        if (!statusSelector) {
          return;
        }
        const statusEl = $(statusSelector);
        if (!statusEl.length) {
          return;
        }
        statusEl.text(query ? `${matchCount} result${matchCount !== 1 ? 's' : ''} found` : '');
      };

      const executeSearch = () => {
        const query = (searchInput.val() || "").toString();
        if (query === previousQuery) {
          return;
        }
        previousQuery = query;
        const tree = $(treeSelector).jstree(true);
        if (tree) {
          tree.search(query, false, true);
          const matchCount = query ? $(treeSelector).find('.jstree-search').length : 0;
          announceResults(query, matchCount);
        }

        const hasQuery = !!(searchInput.val() || "").toString().length;
        searchForm.find(".clear-button").toggle(hasQuery);
        ensureTreeVisible();
      };

      const debouncedSearch = _.debounce(executeSearch, searchDelay);

      searchForm.on("input", debouncedSearch);

      searchForm
        .find(".clear-button")
        .on("click", function () {
          debouncedSearch.cancel();
          previousQuery = null;
          searchInput.val("");
          executeSearch();
          $(this).hide();
        });
    };

    bindTreeSearch({
      formSelector: "#tl_search",
      inputSelector: "#tl_q",
      treeSelector: "#tl_container",
      searchDelay: 120,
      statusSelector: "#tl_search_status",
      ensureTreeVisible: () => {
        if (!libraryTree.data("open")) {
          libraryTree.children(".tree-container").show();
          libraryTree.data("open", true);
          updateTreeviews();
        }
      }
    });

    bindTreeSearch({
      formSelector: "#tm_search",
      inputSelector: "#tm_q",
      treeSelector: "#tm_container",
      searchDelay: 120,
      statusSelector: "#tm_search_status",
      ensureTreeVisible: () => {
        if (!memberTree.data("open")) {
          memberTree.children(".tree-container").show();
          memberTree.data("open", true);
          updateTreeviews();
        }
      }
    });

    $(window).on("resize", function () {
      updateTreeviews();
    });
  }
}
